


































































































import GlobalMixin from "@/shared/mixins/globalMixin";
import Component, { mixins } from "vue-class-component";

//Formulario

import EmailConfig from "./componentes/EmailConfig.vue";
import EmailAgend from "./componentes/EmailAgend.vue";
import FiltroEmailComponent from "./componentes/FiltroEmailComponent.vue";

//Fim formulário

import WysiwygEditor from "@/shared/components/wysiwyg-editor.vue";
import {
  EmailAgendamento,
  EmailConfiguracao,
  EmailFiltro,
  EmailService,
  NovoEmail,
} from "@/services/email.service";
import { ToastService } from "@/services/toast.service";
import { required } from "@/shared/validators";

const tipoEditorMap = {
  "Com formatação": 0,
  "Sem formatação": 1,
};

@Component({
  components: {
    //Formulário

    EmailConfig,
    EmailAgend,
    FiltroEmailComponent,

    //Fim formulário

    WysiwygEditor,
  },
})
export default class Emails extends mixins(GlobalMixin) {
  //Atributos
  config: EmailConfiguracao | null = null;
  agend: EmailAgendamento | null = null;
  filtro: EmailFiltro | null = null;
  tipoEditor: 0 | 1 | number = tipoEditorMap["Com formatação"];

  corpoEmail = "";

  rules = {
    corpoEmail: [required()],
  };

  //Métodos

  agendar() {
    //Validar formulário
    const form = (this.$refs.form as any).validate();
    //Validar ckeditor4
    const corpoEmail =
      (this.tipoEditor == tipoEditorMap["Sem formatação"] && this.corpoEmail) ||
      (this.$refs.corpoEmail as any).validate();

    if (form && corpoEmail) {
      const agendamento = {
        ...this.config,
        ...this.agend,
        ...this.filtro,
        corpoEmail: this.corpoEmail,
      } as NovoEmail;

      this.startLoader();
      EmailService.agendar(agendamento)
        .then(() => {
          ToastService.open({
            position: "top-end",
            message: "E-mail agendado com sucesso!",
            duration: 3000,
            type: "success",
          });
        })
        .finally(this.stopLoader);
    }
  }
}
